import BuildConfig from '$extensionSrc/buildConfig'

import { ControlStageKey } from '../../utils/enums'
import { AUTOMATION_STAGE_STATUSES } from '../genericAutomationStageStatuses'

export const FACEBOOK_AUTOMATION_STAGE_STATUSES = {
  ...AUTOMATION_STAGE_STATUSES,
  START_SETUP: {
    title: `${BuildConfig.TENANT_NAME} is reviewing your settings...`,
    body: 'Keep this tab open.',
  },
  GETTING_ALBUM_URLS: {
    title: `${BuildConfig.TENANT_NAME} is finding all your albums...`,
    body: 'Keep this tab open.',
  },
  NEEDS_USER_INPUT: {
    title: 'Facebook might need your attention',
    body: `${BuildConfig.TENANT_NAME} was interrupted by this page. Facebook may need you to
      re-authenticate to access this setting or if you are logged into a 'Page'
      profile, you may need to switch back to your main profile before clicking
      'Resume'. Otherwise, contact us for support: support@blockpartyapp.com.`,
    stageKey: ControlStageKey.NEEDS_USER_INPUT,
  },
  NEEDS_USER_LOGIN: {
    title: 'Continue by logging into Facebook',
    body: `To see this ${BuildConfig.TENANT_NAME} recommendation, log in to the Facebook account you want to update`,
    stageKey: ControlStageKey.NEEDS_USER_LOGIN,
  },
  FB_UNFRIEND_GATHER: {
    body: 'Keep this tab open.',
    title: `${BuildConfig.TENANT_NAME} is loading your friends...`,
  },
  FB_UNFRIEND_UPDATE: {
    body: 'Keep this tab open.',
    title: `${BuildConfig.TENANT_NAME} is unfriending...`,
  },
  FB_DELETE_START: {
    title: 'Getting started...',
    body: 'Gathering account information.',
  },
  FB_DELETE_END: {
    title: 'Finishing up..',
    body: 'Should be done soon...',
  },
}
